import { type ComponentPropsWithoutRef } from 'react';
import { QuizLogo } from '@/components';
import { cn } from '@/utils';
const SignUp = () => null;
const SingUpWrapper = (props: ComponentPropsWithoutRef<'div'>) => {
  return <div className={cn('flex min-h-[100vh] w-full flex-col items-center bg-gray-50 px-md justify-start tablet-sm:justify-center tablet-sm:px-2xl', props.className)} data-sentry-component="SingUpWrapper" data-sentry-source-file="SignUpWidget.tsx">
      {props.children}
    </div>;
};

/**
 *  섹션을 감싸고 flex-direction, gap 만 경정
 * */
const SignUpContainer = (props: ComponentPropsWithoutRef<'div'>) => {
  const {
    className,
    ...rest
  } = props;
  return <div className={cn(['flex flex-col max-w-[640px] gap-lg tablet-sm:gap-xl py-sm tablet-sm:w-[640px] tablet-sm:py-4xl justify-center', className])} {...rest} data-sentry-component="SignUpContainer" data-sentry-source-file="SignUpWidget.tsx">
      {props.children}
    </div>;
};

/**
 * 입력 및 선택
 * */
const SignUpSection = (props: ComponentPropsWithoutRef<'div'>) => {
  return <div className={cn('flex flex-col min-h-[20vh] tablet-sm:p-2xl tablet-sm:gap-lg gap-md bg-white rounded-[32px] py-lg px-md tablet-sm:min-w-[640px]', 'shadow-[0px_2px_6px_0px_rgba(28,27,31,0.04)]', props.className)} data-sentry-component="SignUpSection" data-sentry-source-file="SignUpWidget.tsx">
      {props.children}
    </div>;
};
const SignUpHeader = (props: ComponentPropsWithoutRef<'div'> & {
  title: string;
  onlySymBole: boolean;
  emoji?: string;
}) => {
  const {
    onlySymBole,
    title,
    ...rest
  } = props;
  return <div className={cn(['flex flex-col gap-sm items-center'])} {...rest} data-sentry-component="SignUpHeader" data-sentry-source-file="SignUpWidget.tsx">
      <QuizLogo className={onlySymBole ? undefined : 'h-[40px]'} onlySymBole={onlySymBole} data-sentry-element="QuizLogo" data-sentry-source-file="SignUpWidget.tsx" />
      <span className={'text-center text-[22.5px] font-extrabold leading-[130%] text-default accent-gray-700 tablet-sm:text-[30px]'}>
        {title}&nbsp;
        {props.emoji && `${props.emoji}️`}
      </span>
    </div>;
};
export const SignUpWidget = Object.assign(SignUp, {
  Wrapper: SingUpWrapper,
  Header: SignUpHeader,
  Container: SignUpContainer,
  Section: SignUpSection
});